var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKatalogschnittstelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "83px",
    viewBox: "0 0 75 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944625 9.5,22.361625 9.5,23.516625 L9.5,51.384625 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384625 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944625 63.2245,20.367125 L39.09,6.433125 Z",
    id: "path-1-katalogschnittstelle"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.6%",
    y: "-9.5%",
    width: "143.2%",
    height: "138.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-katalogschnittstelle"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3-katalogschnittstelle",
    points: "0 0 22.5 0 22.5 27 0 27"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-color-gold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katalogschnittstelle",
    transform: "translate(-715.000000, -986.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p-katalogschnittstelle",
    transform: "translate(208.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-katalogschnittstelle)",
    xlinkHref: "#path-1-katalogschnittstelle"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F3F4",
    fillRule: "evenodd",
    xlinkHref: "#path-1-katalogschnittstelle"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke-color",
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944125 9.5,22.361625 9.5,23.516625 L9.5,51.384125 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384125 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944125 63.2245,20.367125 L39.09,6.433125 Z",
    id: "border-katalogschnittstelle",
    stroke: "#666666",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,6 C36.8886346,6.01803249 36.2852285,6.15628155 35.8201132,6.42676886 L11.8092236,20.3859175 C10.8138273,20.9644598 10,22.3840172 10,23.5411018 L10,51.4588982 C10,52.6159828 10.8138273,54.0360411 11.8092236,54.6145834 L35.8201132,68.5732311 C36.2852285,68.8437184 36.8886346,68.9824684 37.5,69 L37.5,6 Z",
    id: "overlay-katalogschnittstelle",
    fill: "#666666",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-katalogschnittstelle",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-katalogschnittstelle",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3-katalogschnittstelle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2-katalogschnittstelle"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M20.5715932,21.6073523 L19.0196256,21.6073523 L19.0196256,4.42853626 C19.0196256,3.89580345 18.5881485,3.46432102 18.0554222,3.46432102 L5.40862539,3.46432102 L5.40862539,1.92843049 L20.5715932,1.92843049 L20.5715932,21.6073523 Z M1.92877022,25.0711541 L17.0912188,25.0711541 L17.0912188,5.39275151 L1.92877022,5.39275151 L1.92877022,25.0711541 Z M21.5357966,0 L4.44442201,0 C3.91169575,0 3.48021863,0.431482429 3.48021863,0.964215247 L3.48021863,3.46432102 L0.964047612,3.46432102 C0.431840577,3.46432102 -0.000155767912,3.89580345 -0.000155767912,4.42853626 L-0.000155767912,26.0358886 C-0.000155767912,26.5681022 0.431840577,27.0001038 0.964047612,27.0001038 L18.0554222,27.0001038 C18.5881485,27.0001038 19.0196256,26.5681022 19.0196256,26.0358886 L19.0196256,23.5357828 L21.5357966,23.5357828 C22.0685229,23.5357828 22.5,23.1043004 22.5,22.5715676 L22.5,0.964215247 C22.5,0.431482429 22.0685229,0 21.5357966,0 L21.5357966,0 Z",
    id: "Fill-1",
    fill: "#676767",
    mask: "url(#mask-4-katalogschnittstelle)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M4.27193501,11.8262013 L7.57681089,11.8262013 C7.84317402,11.8262013 8.05917219,11.6102004 8.05917219,11.343834 L8.05917219,8.03943669 C8.05917219,7.77307028 7.84317402,7.55706945 7.57681089,7.55706945 L4.27193501,7.55706945 C4.00557188,7.55706945 3.7895737,7.77307028 3.7895737,8.03943669 L3.7895737,11.343834 C3.7895737,11.6102004 4.00557188,11.8262013 4.27193501,11.8262013",
    id: "Fill-4-katalogschnittstelle",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M10.9146057,10.7952646 L14.1852127,10.7952646 C14.7174197,10.7952646 15.149416,10.3632629 15.149416,9.83104935 C15.149416,9.29831653 14.7174197,8.8668341 14.1852127,8.8668341 L10.9146057,8.8668341 C10.3818795,8.8668341 9.95040234,9.29831653 9.95040234,9.83104935 C9.95040234,10.3632629 10.3818795,10.7952646 10.9146057,10.7952646",
    id: "Fill-6-katalogschnittstelle",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M4.27193501,17.3805899 L7.57681089,17.3805899 C7.84317402,17.3805899 8.05917219,17.1651083 8.05917219,16.8982227 L8.05917219,13.5933061 C8.05917219,13.327459 7.84317402,13.1114581 7.57681089,13.1114581 L4.27193501,13.1114581 C4.00557188,13.1114581 3.7895737,13.327459 3.7895737,13.5933061 L3.7895737,16.8982227 C3.7895737,17.1651083 4.00557188,17.3805899 4.27193501,17.3805899",
    id: "Fill-8-katalogschnittstelle",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M10.8679792,16.2872415 L14.1385861,16.2872415 C14.6707932,16.2872415 15.1027895,15.8552398 15.1027895,15.3230262 C15.1027895,14.7902934 14.6707932,14.358811 14.1385861,14.358811 L10.8679792,14.358811 C10.3352529,14.358811 9.90377581,14.7902934 9.90377581,15.3230262 C9.90377581,15.8552398 10.3352529,16.2872415 10.8679792,16.2872415",
    id: "Fill-10-katalogschnittstelle",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M4.27193501,22.90694 L7.57681089,22.90694 C7.84317402,22.90694 8.05917219,22.6914584 8.05917219,22.4245728 L8.05917219,19.1201755 C8.05917219,18.8538091 7.84317402,18.6383275 7.57681089,18.6383275 L4.27193501,18.6383275 C4.00557188,18.6383275 3.7895737,18.8538091 3.7895737,19.1201755 L3.7895737,22.4245728 C3.7895737,22.6914584 4.00557188,22.90694 4.27193501,22.90694",
    id: "Fill-12-katalogschnittstelle",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M10.8228065,21.8686822 L14.0934134,21.8686822 C14.6256205,21.8686822 15.0576168,21.4366805 15.0576168,20.9044669 C15.0576168,20.3717341 14.6256205,19.9402517 14.0934134,19.9402517 L10.8228065,19.9402517 C10.2900802,19.9402517 9.85860312,20.3717341 9.85860312,20.9044669 C9.85860312,21.4366805 10.2900802,21.8686822 10.8228065,21.8686822",
    id: "Fill-14-katalogschnittstelle",
    fill: "#676767"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalogschnittstelle);
export default __webpack_public_path__ + "static/media/katalogschnittstelle.9dfd6b2fa33e4d6525e2287e280dac4f.svg";
export { ForwardRef as ReactComponent };